export default "__VITE_ASSET__Bc2Oa3S1__"